<template>
    <v-layout justify-center>
        <v-responsive max-width="1240" width="100%" class="px-3 mx-n3">
            <list-heading title="서비스 문의" showsFilterButton v-model="showsSearch" />

            <service-inquiry-list-search v-bind="{ showsSearch }" />

            <v-data-table v-bind="{ items, headers, loading }" :items-per-page="-1" disable-pagination disable-sort hide-default-footer show-expand class="v-sheet--outlined" style="overflow-y: hidden">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>

                <template #[`item.inquirer`]="{ item }">
                    <span>{{ item?.meta?.companyName || "-" }}</span> <br />
                    <span>{{ item?.meta?.name || "-" }}</span>
                </template>
                <template #[`item.state`]="{ item, value }">
                    <service-inquiry-state-edit :value="item" v-on="{ update }">
                        <v-card flat tile class="px-4 py-2 my-n2">{{ FORM_STATES__SERVICE_INQUIRY[value]?.text }}</v-card>
                    </service-inquiry-state-edit>
                </template>
                <template #[`item.memo`]="{ item, value }">
                    <form-memo-edit :value="item" v-on="{ update }">
                        <v-card flat tile color="transparent" class="px-4 py-2 my-n2 fill-height"> {{ value || "-" }} </v-card>
                    </form-memo-edit>
                </template>
                <template #expanded-item="{ item, headers }">
                    <td />
                    <td :colspan="headers.length - 1" class="px-0">
                        <v-sheet class="fill-height">
                            <v-card-subtitle class="caption">문의내용</v-card-subtitle>
                            <v-card-text class="white-space-pre-line">
                                {{ item.content }}
                            </v-card-text>
                        </v-sheet>
                    </td>
                </template>
            </v-data-table>

            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { FORM_STATES__SERVICE_INQUIRY } from "@/assets/variables";

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import FormMemoEdit from "@/components/console/forms/form-memo-edit.vue";
import ServiceInquiryStateEdit from "@/components/console/forms/service-inquiry-state-edit.vue";
import ServiceInquiryListSearch from "@/components/console/forms/service-inquiry-list-search.vue";

const code = "service-inquiry";

const headers = [
    { width: 320, text: "문의제목", value: "subject" },
    { width: 100, text: "요청일시", value: "createdAt", formatter: (value) => value?.toDateTime?.() },
    { width: 160, text: "회사명 / 담당자", value: "inquirer" },
    { width: 160, text: "연락처", value: "meta", formatter: ({ phone, email } = {}) => [phone, email].filter((item) => item).join("\n") },
    { width: +90, text: "처리상태", value: "state", cellClass: "px-0" },
    { width: 320, text: "메모", value: "memo", cellClass: "px-0" },
].map((item, index, array) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-"), divider: index != array.length - 1, class: (item.class || "") + " white-space-pre-line", cellClass: (item.cellClass || "") + " caption line-height-1-5 white-space-pre-line py-2" }));

export default {
    components: {
        VDateField,
        ListHeading,
        FormMemoEdit,
        ServiceInquiryStateEdit,
        ServiceInquiryListSearch,
    },
    data: () => ({
        forms: [],

        limit: 10,
        summary: { totalCount: 0 },

        headers,

        loading: false,
        showsSearch: true,
        FORM_STATES__SERVICE_INQUIRY,
    }),
    computed: {
        items() {
            return [...this.forms];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.code = code;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.forms = [];
            this.summary = { totalCount: 0 };

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, forms } = await api.console.forms.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.forms = forms;
            } finally {
                this.loading = false;
            }
        },

        async update(form) {
            if (this.loading) return;
            else this.loading = true;

            try {
                form = (await api.console.forms.put(form))?.form;
                alert("저장되었습니다");
                this.updateItem(form);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(form) {
            const index = this.forms.findIndex(({ _id }) => _id == form._id);
            if (0 <= index) this.forms.splice(index, 1, form);
            else {
                this.forms = [form, ...this.forms];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
}
</style>
